import {createContext} from "react";

export const PackingContext  = createContext({
    cancellationReasons: [],
    openProductProblemDrawer: false,
    setOpenProductProblemDrawer: () => {},
    handleAllItemAreCancelled: () => {},
    handlePackItem: () => {},
    packingLoading: false,
    setPackingLoading: () => {},
    multiExpSessionOrderIndex: 0,
    multiExpSessionShipmentIndex: 0,
    nextShipment: () => {},
    handleForceStopMultiPackingSession: () => {},
    shipmentSplitNewShipment: null,
    isPartialExpedition: false,
    setIsPartialExpedition: () => {},
    shipmentTrackingNumber: null,
    setShipmentTrackingNumber: () => {},
    packingStep: null,
    setPackingStep: () => {},
    currentWorkstation: null,
    getItemIndex: () => {},
    openToBeCancelledModal: false,
    setOpenToBeCancelledModal: () => {},
    toBeCancelledItem: {},
    setToBeCancelledItem: () => {},
})
